<template>
  <TooltipIconButton
    icon="mdi-file-replace"
    :tooltipText="text"
    :color="color"
    :disabled="disabled"
    v-on="$listeners"
  />
</template>

<script>
export default {
  name: 'UpdateButton',
  props: {
    color: {
      type: String,
      default: 'red',
    },
    text: {
      type: String,
      default: 'tooltip.update',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
